import raf              from 'raf';
import helperA11y       from 'shared/mixins/helper-a11y';

/**
 * @module
 */
 
const selector = '[data-js-flip]';
const flip = function(el, app) {

    const a11yHelper = helperA11y(app);

    const $document = $(document);
    const $el = $(el);
    let   status = false;       // false: side1 (the "first" side). true: side 2
    const duration = 500;       // duration of the flip
    const $flip1 = $el.find('.Ge-Flip-Side1');
    const $flip2 = $el.find('.Ge-Flip-Side2');
    let   flipTimer = null;     // used in the cleanup after a flip.
    let   flipId = null;        // optional id used to tie up flip buttons that outside of this module, somehere on the page
    let   $btnToggle = null;    // any buttons that toggle the flip in an indeterminate direction
    let   $btnTo1 = null;       // any buttons that toggle the flip to side 1 (first side)
    let   $btnTo2 = null;       // any buttons that toggle the flip to side 2 (second side)
    let   flip1Height = 0;
    let   flip2Height = 0;
    
    let ww = $(window).width();
    let wh = $(window).height();
    const sw = screen.width;

    const init = function() {
        // does this flip have an id that is used in buttons somewhere in the page?
        flipId = $el.attr('data-flip-id');
        // find the buttons (if outside of this instance - somewhere on the page - they need to relate to an id of this flip. Otherwise, look for buttons inside this flip).
        $btnToggle = (flipId != undefined ? $('[data-js-flip-btn="' + flipId + '"]') : $(el).find('[data-js-flip-btn]') );
        $btnTo1 = (flipId != undefined ? $('[data-js-flip-btn-to-1="' + flipId + '"]') : $(el).find('[data-js-flip-btn-to-1]') );
        $btnTo2 = (flipId != undefined ? $('[data-js-flip-btn-to-2="' + flipId + '"]') : $(el).find('[data-js-flip-btn-to-2]') );
        // measure which side is tallest
        measure();
        // set the initial size of the flip
        setSize();
        // flip events
        registerEvents();
        // inital state
        if ($el.attr('data-flip-init-side2') != undefined) {
            status = true;
            flip2();
        } else {
            flip1();
        }

        // set up the resize event
        onResizeSetUp();

        // next frame, mark as ready and set up the animation
        raf(function tick1() {
            raf(function tick2() {
                $el.addClass('Ge-Flip--animate');
                $el.addClass('Ge-Flip--ready');
                $el.trigger('flipReady');
                app.trigger('flipReady');
            });
        });

        el.interface = {
            update: function() {
                updateSize();
            }
        };
    };

    const updateSize = function() {
        $el.css("height","unset");
        $el.removeClass("Ge-Flip--ready");
        $el.removeClass("Ge-Flip--animate");
        measure();
        setSize();
        raf(function tick1() {
            raf(function tick2() {
                $el.addClass("Ge-Flip--ready");
                $el.addClass("Ge-Flip--animate");
            });
        });
    }

    const measure = function() {
        flip1Height = $flip1[0].offsetHeight;
        flip2Height = $flip2[0].offsetHeight;
    };

    const setSize = function() {
        $(el).height(Math.max(flip1Height,flip2Height));
    };
    
    const registerEvents = function() {
        // buttons
        $btnToggle.click(flip);
        $btnTo1.click(flip1);
        $btnTo2.click(flip2);
        // triggered events
        $el.on('flip',flip);
        $el.on('flip2',flip2);
        $el.on('flip1',flip1);
    };
    
    // flip toggle (direction indeterminate)
    const flip = function(ev) {
        if (status) {
            flip1(ev);
        } else {
            flip2(ev);
        }
    };
    
    // flip back to the first side
    const flip1 = function(ev) {
        // stop any cleanup, we're about to do it again
        clearTimeout(flipTimer);
        // kill pop-overs that might now appear backwards
        app.trigger('killAllPops');
        // flip
        $el.removeClass('Ge-Flip--active');
        // set the new status
        status = false;
        // aria/accessibility
        a11yHelper.show($el.find('.Ge-Flip-Side1'));
        a11yHelper.hide($el.find('.Ge-Flip-Side2'));
        a11yHelper.reFocus(ev, $el.find('[data-js-flip-btn-to-2]'));
        // carry out any cleanup
        cleanUp();
    };
    
    // flip back to the second side
    const flip2 = function(ev) {
        // stop any cleanup, we're about to do it again
        clearTimeout(flipTimer);
        // kill pop-overs that might now appear backwards
        app.trigger('killAllPops');
        // flip
        $el.addClass('Ge-Flip--active');
        // set the new status
        status = true;
        // aria/accessibility
        a11yHelper.hide($el.find('.Ge-Flip-Side1'));
        a11yHelper.show($el.find('.Ge-Flip-Side2'));
        a11yHelper.reFocus(ev, $el.find('[data-js-flip-btn-to-1]'));
        // carry out any cleanup
        cleanUp();
    };

    // after a flip has completed
    const cleanUp = function() {
        flipTimer = setTimeout(function() {
            $el.trigger('flipComplete');
            app.trigger('flipComplete');
        },duration);
    };

    // things need to be re-positioned when the window is resized
    const onResizeSetUp = function() {

        if( sw <= 600 ){
            return;
        }

        // try and detect scrolling vs resizing
        let scrolling = false;
        let scrollTimer = false;
        $(window).scroll(function duringScroll (ev) {
            clearTimeout(scrollTimer);
            scrolling = true;
            scrollTimer = setTimeout(function() {
                scrolling = false;
            },50);
        });

        // set off resize event
        let resizeTimer = false;
        $(window).resize(function onResizeUnThrottled (ev) {

            // check for scrolling first
            if (scrolling) {
                $el.addClass('Ge-Flip--ready');
                return;
            }

            // Assume window height does not affect flip heights
            // Most mobile browsers hide and show the ui-chrome when 
            // scrolling and fire multiple resize events for different heights
            const w = $(window).width();

            if( w === ww ){
                $el.addClass('Ge-Flip--ready');
                return;
            }

            ww = w;

            // hide everything while we measure
            // detect the end of a resize
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function resizeFinished () {
                updateSize();
            },50);
            
        });

    };

    return {
        init: init()
    };
};

flip.selector = selector;

export default flip;
